import * as BulkEditsReducer       from './bulk-edits-reducer'
import * as DataStatusReducer      from './data-status-reducer'
import * as MapNotesReducer        from './map-notes-reducer'
import * as ModalReducer           from './modal-reducer'
import * as ModeReducer            from './mode-reducer'
import * as PoiStatusReducers      from './poi-status-reducers'
import * as PublishStatusReducer   from './publish-status-reducer'
import * as SessionReducer         from './session-reducer'
import * as SpritesheetReducer     from './spritesheet-reducer'
import * as ViewReducer            from './view-reducer'

const reducers = {
    boonPoiEdits       : PoiStatusReducers.reducers.boonPoiEdits,
    boonPoiErrorMessage: PoiStatusReducers.reducers.boonPoiErrorMessage,
    boonPoiStatus      : PoiStatusReducers.reducers.boonPoiStatus,
    bulkEdits          : BulkEditsReducer.reducer,
    dataStatus         : DataStatusReducer.reducer,
    mapNotes           : MapNotesReducer.reducer,
    modal              : ModalReducer.reducer,
    mode               : ModeReducer.reducer,
    publishStatus      : PublishStatusReducer.reducer,
    session            : SessionReducer.reducer,
    spritesheet        : SpritesheetReducer.reducer,
    view               : ViewReducer.reducer,
}

export {
    reducers,
    BulkEditsReducer,
    DataStatusReducer,
    MapNotesReducer,
    ModalReducer,
    ModeReducer,
    PoiStatusReducers,
    PublishStatusReducer,
    SessionReducer,
    SpritesheetReducer,
    ViewReducer,
}



